import { configureStore } from '@reduxjs/toolkit';
import sidenavSlice from './sidenavSlice';
import notificationsSlice from './notificationSlice';
import tabularSlice from './tabularSlice';
import workSettingsSlice from './workSettingsSlice';
import salarySlice from './salarySlice';
export const store = configureStore({
  reducer: {
    sideNav: sidenavSlice,
    notifications: notificationsSlice,
    tabs: tabularSlice,
    workSettings: workSettingsSlice,
    salary: salarySlice,
  },
});

export type IRootState = ReturnType<typeof store.getState>;
export type IAppDispatch = typeof store.dispatch;
